import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import { useContext } from "react";
import { useParams } from "react-router-dom";

import AppContext from "./context";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

function ProductPage() {
  const { productsData, productsIsLoading } = useContext(AppContext);
  const { Id: productId } = useParams();
  return (
    <div className="body">
      {!productsIsLoading ? (
        <div
          style={{
            backgroundColor: "var(--gray-white)",
            display: "flex",
          }}
        >
          <img
            alt={"product"}
            src={`https://binesh-motahar.liara.run/assets/${productsData.data[productId].image.id}`}
            className="image article"
          />
        </div>
      ) : (
        <div className="Image loading"></div>
      )}

      <div className="introduction">
        <p className="text l-500">
          {!productsIsLoading
            ? productsData.data[productId - 1].title
            : "متن مقاله"}
        </p>
        <p className="text m-400" style={{ padding: "16px 0 16px 0" }}>
          {!productsIsLoading
            ? productsData.data[productId - 1].description
            : "متن مقاله"}
        </p>
      </div>
    </div>
  );
}

export default ProductPage;
